import * as React from "react";

const IconBreadcrumbsCaretRight: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="6" height="11" viewBox="0 0 6 11" fill="currentColor"><polygon fill="currentColor" points="5.341 4.545 4.943 4.943 1.195 8.693 .797 9.091 .002 8.295 .401 7.896 3.752 4.545 .398 1.193 0 .795 .797 0 1.195 .398 4.945 4.146 5.344 4.545" transform="translate(.453 .956)"/></svg>;
};

export default React.memo(IconBreadcrumbsCaretRight);
